import { CircumstanceCard } from "./CircumstanceCard";

export default CircumstanceCard;
